// MobileOverlay.js
import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const overlayVariants = {
    visible: { opacity: 1, pointerEvents: 'auto' },
    hidden: { opacity: 0, pointerEvents: 'none' },
};

export default function MobileOverlay() {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const dismissed = localStorage.getItem('overlayDismissed');
        if (dismissed !== 'true') {
            setIsVisible(true);
        }
    }, []);

    const handleClose = () => {
        localStorage.setItem('overlayDismissed', 'true');
        setIsVisible(false);
    };

    return (
        <AnimatePresence>
            {isVisible && (
                <motion.div
                    className="mobile-overlay"
                    variants={overlayVariants}
                    initial="visible"
                    animate="visible"
                    exit="hidden"
                    onClick={handleClose}
                    transition={{ duration: 0.5 }}
                >
                    <div className="background-blur"></div>
                    <h1>Game Engine</h1>
                    <p>Tap - Black Hole</p>
                    <p>Hold and Move - Bomb</p>
                    <p>Tap twice - Eraser Menu</p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
                        <path d="M45.999 31.25L22.499 45.95L19.999 47.5V15L45.999 31.25ZM41.249 31.25L22.499 19.5V43L41.249 31.25Z" fill="#B3B3B3" />
                    </svg>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
